import ORIGIN from '../../assets/scalp/sample/ORIGIN.png';
import {
  SCALP_SENSITIVITY_DATA,
  SCALP_HAIR_QUANTITY,
  SCALP_HAIR_FOLLICLE_DENSITY,
  SCALP_DEAD_SKIN_DATA,
  SCALP_HEALTH_SCORE_DATA,
} from './dummyDiagnosisItems';

export const dummyHistoryFilter = {
  diagnosisItemType: 'SCALP_HEALTH_SCORE',
  scalpPoint: 'ALL',
};

const getObjInfo = (diagnosisItem) => {
  let items = [];
  for (let i = 0; i <= 2; i++) {
    items.push({ ...diagnosisItem, id: items.length });
  }
  return items;
};
export const scalpDummyHistory = {
  ALL: {
    SCALP_HEALTH_SCORE: [...getObjInfo(SCALP_HEALTH_SCORE_DATA)],
    SENSITIVITY: [...getObjInfo(SCALP_SENSITIVITY_DATA)],
    DEAD_SKIN: [...getObjInfo(SCALP_DEAD_SKIN_DATA)],
    HAIR_FOLLICLE_DENSITY: [...getObjInfo(SCALP_HAIR_FOLLICLE_DENSITY)],
    HAIR_QUANTITY: [...getObjInfo(SCALP_HAIR_QUANTITY)],
  },
  FOREHEAD: {
    SCALP_HEALTH_SCORE: [...getObjInfo(SCALP_HEALTH_SCORE_DATA)],
    SENSITIVITY: [...getObjInfo(SCALP_SENSITIVITY_DATA)],
    DEAD_SKIN: [...getObjInfo(SCALP_DEAD_SKIN_DATA)],
    HAIR_FOLLICLE_DENSITY: [...getObjInfo(SCALP_HAIR_FOLLICLE_DENSITY)],
    HAIR_QUANTITY: [...getObjInfo(SCALP_HAIR_QUANTITY)],
  },
  CROWN: {
    SCALP_HEALTH_SCORE: [],
    SENSITIVITY: [],
    DEAD_SKIN: [],
    HAIR_FOLLICLE_DENSITY: [],
    HAIR_QUANTITY: [],
  },
  HIND_HEAD: {
    SCALP_HEALTH_SCORE: [],
    SENSITIVITY: [],
    DEAD_SKIN: [],
    HAIR_FOLLICLE_DENSITY: [],
    HAIR_QUANTITY: [],
  },
  SIDE_HEAD: {
    SCALP_HEALTH_SCORE: [],
    SENSITIVITY: [],
    DEAD_SKIN: [],
    HAIR_FOLLICLE_DENSITY: [],
    HAIR_QUANTITY: [],
  },
};

export const dummyHistory = [
  {
    id: 1,
    analysisDate: '2022-07-12',
    diagnosisDate: '22.07.12 00:07',
    analysisItemType: 'SCALP_HEALTH_SCORE',
    scalpPoint: 'FOREHEAD_CENTER',
    image: ORIGIN,
    value: 70,
    averages: {
      my: 73.9403,
      all: {
        average: 76.75,
        population: 88,
      },
    },
    hexagonalScores: {
      my: {
        deadSkin: 100,
        hairFollicleDensity: 60,
        hairQuantity: 58,
        sensitivity: 86,
        temperature: 100,
        water: 80,
      },
      averages: {
        deadSkin: 90.2955,
        hairFollicleDensity: 69.5227,
        hairQuantity: 68.3068,
        scalpHealthScore: 76.75,
        sensitivity: 82.4205,
        temperature: 92.8409,
        water: 85.1136,
      },
    },
  },
  {
    id: 2,
    analysisDate: '2022-07-12',
    diagnosisDate: '22.07.12 00:07',
    analysisItemType: 'SCALP_HEALTH_SCORE',
    scalpPoint: 'FOREHEAD_CENTER',
    image: ORIGIN,
    value: 70,
    averages: {
      my: 73.9403,
      all: {
        average: 76.75,
        population: 88,
      },
    },
    hexagonalScores: {
      my: {
        deadSkin: 100,
        hairFollicleDensity: 60,
        hairQuantity: 58,
        sensitivity: 86,
        temperature: 100,
        water: 80,
      },
      averages: {
        deadSkin: 90.2955,
        hairFollicleDensity: 69.5227,
        hairQuantity: 68.3068,
        scalpHealthScore: 76.75,
        sensitivity: 82.4205,
        temperature: 92.8409,
        water: 85.1136,
      },
    },
  },
  {
    id: 3,
    analysisDate: '2022-07-12',
    diagnosisDate: '22.07.12 00:07',
    analysisItemType: 'SCALP_HEALTH_SCORE',
    scalpPoint: 'FOREHEAD_CENTER',
    image: ORIGIN,
    value: 70,
    averages: {
      my: 73.9403,
      all: {
        average: 76.75,
        population: 88,
      },
    },
    hexagonalScores: {
      my: {
        deadSkin: 100,
        hairFollicleDensity: 60,
        hairQuantity: 58,
        sensitivity: 86,
        temperature: 100,
        water: 80,
      },
      averages: {
        deadSkin: 90.2955,
        hairFollicleDensity: 69.5227,
        hairQuantity: 68.3068,
        scalpHealthScore: 76.75,
        sensitivity: 82.4205,
        temperature: 92.8409,
        water: 85.1136,
      },
    },
  },
];
